import {AuwBaseComponent} from "EXT/auw_config/Resources/Private/Js/AuwBaseComponent";
import {AuwMasonry} from "EXT/auw_pages_meta/Resources/Private/Js/AuwMasonry";
import {AuwAjaxFilter} from "EXT/auw_pages_meta/Resources/Private/Js/AuwAjaxFilter";

export class AuwAjaxLoader extends AuwBaseComponent{

    constructor($el){
        super($el);

        this.config = {

        }

    }

    init(){
        this.targetPageCollector = $('#'+this.config.targetPageCollector);
        this.$el = this.targetPageCollector.find('.ajax-loader');
        this.filterContainer = this.targetPageCollector.find(".ajax-filter");
        this.teaserContainer = this.targetPageCollector.find(".teaser__list")
        this.isRequesting = false;
        this.config.buttonText = this.$el.html();
        this.isWall = this.targetPageCollector.hasClass('teaser__list--teaser_wall');
        this.hideButtonIfNotNeeded();

    }


    __PageReady(){
        this.init();
        this.bindEvents();
    }

    bindEvents(){
        if(this.$el){
            this.$el.on("click",this.loaderItemClicked.bind(this));
        }
    }

    loaderItemClicked(e){
        e.preventDefault();
        if(!this.isRequesting) {
            this.isRequesting = true;
            this.setButtonBusy(true);

            var arg = {};
            arg.requestParameter = {ajaxPage:this.$el.data('ajaxPage'),ajaxCid:this.config.targetCid};

            //check if active filters are present
            if(this.filterContainer.length){
                arg.requestParameter.ajaxFilterTags = JSON.stringify(this.filterContainer.data('filterTags'));
                arg.requestParameter.ajaxFilterPageTypes = JSON.stringify(this.filterContainer.data('filterPageTypes'));
            }


            this.ajaxRequest = $.ajax({
                                          type:"GET",
                                          url:this.config.ajaxUri,
                                          data:arg,
                                      })
                                .done(this.parseAnswer.bind(this))
                                .fail( console.error)
                                .always( this.requestFinished.bind(this));
        }
    }

    requestFinished(){
        this.isRequesting = false;
    }

    parseAnswer(data){
        //wenn es eine Wall war
        if(this.isWall){
            var newTeasers = $(data).find('.grid');
        }else{
            var newTeasers = $(data).find(".teaser__item");
        }
        if(newTeasers.length){
            if(this.isWall){
                newTeasers.insertAfter(this.teaserContainer.find(".grid").last());
            }else{
                newTeasers.insertAfter(this.teaserContainer.find(".teaser__item").last());
            }
            this.$el.data("ajaxPage",this.$el.data('ajaxPage')+1);
        }

        this.hideButtonIfNotNeeded();
        this.setButtonBusy(false);

        //wenn es mit masonry war
        var elementWithMasonry = this.targetPageCollector.find('.with-masonry');
        if(elementWithMasonry.length){
            new AuwMasonry(elementWithMasonry);
        }


    }

    hideButtonIfNotNeeded(){
        if(this.teaserContainer.find(".teaser__item").length >= this.config.maxPages){
            this.$el.hide();
        }
    }

    setButtonBusy(busy){
        if(busy){
            this.$el.html("<i class='fas fa-spinner fa-spin'></i>");
        }else{
            this.$el.html(this.config.buttonText);
        }
    }

}